import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=33c1b521&scoped=true&lang=pug&"
import script from "./scripts/UserDetail.js?vue&type=script&lang=js&"
export * from "./scripts/UserDetail.js?vue&type=script&lang=js&"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=33c1b521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c1b521",
  null
  
)

export default component.exports